import useWindowDimensions from "./useWindowDimensions";

function useDeviceType() {
    const { width } = useWindowDimensions();

    // Breakpoints for different screen sizes (based on Tailwind CSS)
    const isSm = width >= 640 && width <= 767;  // Small screens (640px - 767px)
    const isMd = width >= 768 && width <= 1023; // Medium screens (768px - 1023px)
    const isLg = width >= 1024 && width <= 1279; // Large screens (1024px - 1279px)
    const isXl = width >= 1280 && width <= 1535; // Extra-large screens (1280px - 1535px)
    const is2Xl = width >= 1536; // 2XL screens (1536px+)

    // Device type checks for Desktop, Tablet, and Mobile
    const isDesktop = width >= 1025; // Desktop devices
    const isTablet = width >= 768 && width <= 1024; // Tablet devices
    const isMobile = width <= 767; // Mobile devices

    const reValue = ({ sm, md, lg, xl, xxl, defaultValue }) => {
        if (isSm) return sm;
        if (isMd) return md;
        if (isLg) return lg;
        if (isXl) return xl;
        if (is2Xl) return xxl;
        return defaultValue; // Return default value if none of the conditions match
    };

    const reValue2 = ({ desktop, tablet, mobile }) => {
        if (isDesktop) return desktop;
        if (isTablet) return tablet;
        if (isMobile) return mobile;
    };

    return { 
        isSm, isMd, isLg, isXl, is2Xl, 
        isDesktop, isTablet, isMobile, 
        reValue, reValue2 
    };
}

export default useDeviceType;
